module.exports = __webpack_public_path__ + "static/media/trash-biohazard.a26ff819.svg";